import { View } from 'react-native';
import { Text } from '@/components/Text';
import { TextLink } from '@/components/TextLink';
import { isPatientApp } from '@/config/constants';
import { Section } from '@/components/SharedComponents/AboutNeolexon/Section';
import { styles } from './styles';
import { Links } from '@/config/links';

export const AccountDelete = () => {
  return (
    <View style={styles.wrapper}>
      <Text style={styles.bodyText}>
        Wenn Sie die vollständige und unwiderrufliche Löschung aller Ihrer bei
        uns gespeicherten Daten und Ihres gesamten Benutzerkontos wünschen,
        bestätigen Sie dies bitte mit dem Klick auf „unwiderruflich löschen".
        Bitte beachten Sie, dass diese Löschung nicht wieder rückgängig gemacht
        werden kann. Falls Sie dies wünschen, können Sie vor der Löschung Ihre
        Daten
        <TextLink href={Links.export.href}>
          <Text style={styles.linkText}> hier </Text>
        </TextLink>
        unter Mein Account exportieren und abspeichern.
      </Text>
      {isPatientApp ? (
        <Section
          title="Bitte beachten Sie:"
          content="Ihr:e Therapeut:in hat evtl. im Therapeuten-Account noch persönliche Daten über Sie gespeichert. Diese Daten (z.B. Profil mit Ihrem
            Namen, Geburtsdatum, Diagnose, individuelles Übungsmaterial) wurden
            im Therapeuten-Account angelegt, um Ihr Eigentraining einzustellen.
            Diese Daten werden nicht von uns gelöscht. Wenn Sie die Löschung
            dieser Daten wünschen, wenden Sie sich bitte an Ihre:n Therapeut:in."
        />
      ) : null}
    </View>
  );
};
